import { render, staticRenderFns } from "./RecoverySimulatorByBrand.vue?vue&type=template&id=ded70aae"
import script from "./RecoverySimulatorByBrand.vue?vue&type=script&lang=js"
export * from "./RecoverySimulatorByBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports